<!-- Con module.active !== false vengono presi sia quelli a true, sia quelli a undefined (box dei moduli o sottomoduli non ancora gestiti)-->
<template>
    <Link
        :key="module.id"
        class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-6 w-44 h-44 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition
               w-full sm:w-44"
        :href="module.href"
        v-if="module.active !== false"
    >
        <v-icon :name="module.icon" class="mb-3 mt-2" scale="1.5" />
        <p class="text-l font-semibold text-gray-900 dark:text-gray-100">{{ $t('modules.' + module.slug) }}</p>
    </Link>
    <div
        v-else
        class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-6 w-44 h-44 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition
               w-full sm:w-44"
    >
        <v-icon :name="module.icon" class="mb-3 mt-2 text-gray-400" scale="1.5" />
        <p class="text-l font-semibold text-gray-400 dark:text-gray-100">{{ $t('modules.' + module.slug) }}</p>
    </div>
</template>
<script>

import { Link } from '@inertiajs/vue3';

export default {
    components: {
        Link
    },
    props: ['module'],
    computed: {
        selectedIcon() {
            return this.icons[this.module.icon] || null;
        }
    }
}
</script>